import axios from 'axios';
import { Cookies } from 'react-cookie';
import { URL_FOUNDATION } from '../../../config/keys';
import { OpportunityPostParam, OpportunityStatus } from '../model/Model';
import { OpportunityRow } from 'bindings/opportunities/OpportunityRow';
import { FilterParameter } from '../../../components_v2/filter/pages/FilterList';
import { ServerAdvancedFilter } from '../../client-companies/model/Model';
import { translateToString } from '../../../styles/global/translate';

const cookies = new Cookies();
const token = cookies.get('id_token') || null;

axios.defaults.headers.common.Authorization = `${token}`;

export async function postOpportunity(params: OpportunityPostParam): Promise<number> {
	try {
		const result = await axios.post(`${URL_FOUNDATION}/api/v2/client-companies/${params.client_company_id}/opportunities`, params)
			.then(response => {
				return response.data;
			});
		return result;
	} catch (error) {
		console.error(error);
		return -1;
	}
}

export async function getOpportunityStatuses(): Promise<OpportunityStatus[]> {
	try {
		const result = await axios.get<OpportunityStatus[]>(`${URL_FOUNDATION}/api/v2/opportunities/statuses`)
			.then(response => {
				return response.data;
			});
		return result;
	} catch (error) {
		console.error(error);
		return [];
	}
}

export async function queryOpportunities(params: object): Promise<OpportunityRow[]> {
	return axios.post<OpportunityRow[]>(`${URL_FOUNDATION}/api/v2/opportunities/query`, params).then(res => res.data);
}

export async function getOpportunity(id: number): Promise<OpportunityRow> {
	return axios.get<OpportunityRow>(`${URL_FOUNDATION}/api/v2/opportunities/${id}`).then(res => res.data);
}

// a missing key leaves the field unmodified, null clears it
export type QueryUpdateOpportunity = {
	owner_id?: number,
	opportunity_status_id?: number,
	client_company_id?: number,
	title?: string | null,
	contact_id?: number | null,
	deadline?: string | null,
	amount?: number | null,
	probability?: number | null,
	prospect_origin?: number | null,
	description?: string | null
}

export async function updateOpportunity(id: number, params: QueryUpdateOpportunity): Promise<void> {
	return axios.put(`${URL_FOUNDATION}/api/v2/opportunities/${id}`, params);
}

export async function deleteOpportunity(id: number): Promise<void> {
	return axios.delete(`${URL_FOUNDATION}/api/v2/opportunities/${id}`);
}

export async function getOpportunityFilters(): Promise<FilterParameter[]> {
	return axios.get<ServerAdvancedFilter[]>(`${URL_FOUNDATION}/api/v2/opportunities/filters`)
		.then(res => [{
			category: translateToString('opportunities'),
			filters: res.data.map(([id, type]) => ({ id, name: translateToString(id === 'owner_id' ? 'owner' : id === 'tag_id' ? 'tags' : id === 'opportunity_status_id' ? 'status' : String(id)), type }))
		}])
		.catch(e => {
			console.error(e);
			return [];
		});
}
